var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPersonCircle = function SvgPersonCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C15.6534 6 15.8818 9.55512 15.8818 11.333C15.8818 12.3481 15.1374 13.3634 14.498 14.0479C14.0825 14.4923 14.1244 15.2302 14.6387 15.5635L16.6309 16.8564C16.9678 17.0751 17.2513 17.3634 17.46 17.7012C17.6685 18.0389 17.7976 18.4175 17.8379 18.8096L17.9619 20.0283C16.2971 21.2667 14.2343 22 12 22C9.76518 22 7.70212 21.2662 6.03711 20.0273L6.16211 18.8096C6.20226 18.4176 6.33167 18.0389 6.54004 17.7012C6.74844 17.3635 7.03153 17.0751 7.36816 16.8564L9.3623 15.5635C9.87627 15.2292 9.91747 14.4931 9.50195 14.0479C8.86259 13.3634 8.11816 12.3481 8.11816 11.333C8.11819 9.55514 8.34671 6.00006 12 6Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPersonCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "person-circle.37b160edf51c8d4341448b37ad0d63c8.svg";